// FT-077: переиспользуемая логика seat-пейвола (маркетинговый блок при превышении лимита мест).
// Бэкенд хард-гейтит создание active-юзера / реактивацию и отдаёт 422
// { error:"user_limit_reached", limit, count, extra_user_price, currency }. Этот микс ловит такой
// 422, открывает SeatLimitDialog, покупает доп.место (POST /api/v1/company_addons {code:extra_user})
// и ретраит исходное действие. Используется в CreateEmployee/CreateAgent (добавление) и admin/users/Edit
// (активация).
export default {
  data() {
    return { seatPaywall: { show: false, info: null, busy: false } };
  },
  methods: {
    // true (+ открывает пейвол), если ошибка — seat-лимит 422. Иначе false (обычная обработка).
    maybeSeatPaywall(error) {
      const data =
        error && error.response && error.response?.status === 422 && error.response?.data;
      if (data && data.error === "user_limit_reached") {
        this.seatPaywall.info = data;
        this.seatPaywall.show = true;
        return true;
      }
      return false;
    },
    // Покупка N доп.мест → refresh main_company (лимит/счётчик) → retry-колбэк (повтор действия).
    buyExtraUser(retryFn, quantity) {
      const qty = Math.max(1, parseInt(quantity, 10) || 1);
      this.seatPaywall.busy = true;
      this.axios
        .post(
          "/api/v1/company_addons",
          { code: "extra_user", quantity: qty },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then(() => this.refreshMainCompanySeat())
        .then(() => {
          this.seatPaywall.show = false;
          if (typeof retryFn === "function") retryFn();
        })
        .catch((e) => {
          const err = e.response && e.response?.data;
          // FT-077: сервер не даёт уйти в минус — недостаточно баланса → понятное сообщение,
          // пейвол оставляем открытым (можно пополнить и повторить).
          if (err && err.error === "insufficient_balance") {
            this.$notify(
              this.$t("seat_paywall.insufficient_balance_title"),
              this.$t("seat_paywall.insufficient_balance_text"),
              "warning",
              8000
            );
            return;
          }
          this.$notify(this.$t("errors.error"), (err && err.error) || "", "error", 5000);
        })
        .finally(() => {
          this.seatPaywall.busy = false;
        });
    },
    // Перетягивает свежую main_company (effective_users_limit + active_users_count) в стор.
    refreshMainCompanySeat() {
      const mc = this.$store.getters.getMainCompany;
      const mcId = mc && mc.id;
      if (!mcId) return Promise.resolve();
      return this.axios
        .get(`api/v1/main_companies/${mcId}`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((r) => this.$store.commit("setMainCompany", r.data))
        .catch(() => {});
    },
    seatPaywallToTariff() {
      this.seatPaywall.show = false;
      this.$router.push({ name: "Transactions" }).catch(() => {});
    },
  },
};
